import { Button, Icon } from "semantic-ui-react"
import styles from './ClubPage.module.css';

const onWhatsupClick = (text: string) => {
    let path = `https://wa.me/994512515100?text=${text}`;
    window.location.href = path;
}
const Ambassador = () => {
    return <section className={styles.priceTable}>
        <header className={styles.priceTable__header}>
            <h1 className={styles.priceTable__title}>Ambassador</h1>
        </header>
        <table width={300} className={styles.priceTable__table}>
            <tbody>
                <tr>
                    <td>мероприятия</td>
                    <td className={styles.priceRight}>бесплатно</td>
                </tr>
                <tr>
                    <td>гастрономические туры</td>
                    <td className={styles.priceRight}>бесплатно</td>
                </tr>
                <tr>
                    <td>онлайн-семинары</td>
                    <td className={styles.priceRight}>бесплатно</td>
                </tr>
                <tr>
                    <td>участие в аукционах</td>
                    <td className={styles.priceRight}>бесплатно</td>
                </tr>
                <tr>
                    <td>охота на трюфели 1 раз в год</td>
                    <td className={styles.priceRight}>бесплатно</td>
                </tr>
                <tr><td className={styles.biginfo} colSpan={2}><span className={styles.price}>159 </span></td></tr>
                {/* {(!showForm) && <tr><td className={styles.biginfo} colSpan={2}>
                                            <Button onClick={onShowFormClick} type='button' color='google plus' icon labelPosition='left' size='small'>
                                                <Icon name='search plus' />
                                                заказать тур
                                            </Button>
                                        </td></tr>} */}
                <tr><td className={styles.biginfo} colSpan={2}>
                    <Button onClick={x => onWhatsupClick(`Cтать членом клуба - "Ambassador"`)} type='button' color='green' icon labelPosition='left' size='small'>
                        <Icon name='whatsapp' />
                        Cтань членом клуба
                    </Button>
                </td></tr>
            </tbody>
        </table>
    </section>


}

export default Ambassador